<template>
    <div>
        <canvas :id="`grafica-${dia}`" ref="canvasGrafica"></canvas>
        <!--<v-btn color="primary" small class="mt-2" @click="descargarGraficaComoPNG">
            📥 Descargar gráfica
        </v-btn>-->
    </div>
</template>

<script>
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.register(ChartDataLabels);

export default {
    name: 'GraficaDiaFinal',
    props: {
        activo: Boolean,
        dia: { type: String, required: true },
        intervalos: { type: Array, required: true }, // ej: ['08:00', '08:30', ...]
        asignados: { type: Array, required: true }, // barras por intervalo
        programados: { type: Array, required: true }, // línea roja
        requeridos: { type: Array, required: true }, // línea amarilla
        maxY: { type: Number, default: null }
    },
    data() {
        return {
            chart: null
        }
    },
    computed: {
        maxYValue() {
            const allData = [...this.asignados, ...this.programados, ...this.requeridos];

            const max = Math.max(...allData);
            return Math.ceil(max * 1.15);
        }
    },
    mounted() {
        const ctx = this.$refs.canvasGrafica.getContext('2d');

        this.chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: this.intervalos,
                datasets: [
                    {
                        type: 'bar',
                        label: 'Programados',
                        data: this.asignados,
                        backgroundColor: 'rgba(0, 123, 255, 0.6)',
                        borderColor: 'rgba(0, 123, 255, 1)',
                        borderWidth: 1
                    },
                    {
                        type: 'line',
                        label: 'Requeridos con reductores',
                        data: this.programados,
                        borderColor: 'red',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.1
                    },
                    {
                        type: 'line',
                        label: 'Requeridos sin reductores ',
                        data: this.requeridos,
                        borderColor: 'orange',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.1
                    }
                ]
            },
            options: {
                responsive: true,

                plugins: {
                    legend: { position: 'top' },
                    labels: {
                        padding: 25
                    },
                    title: {
                        display: true,
                        text: `Distribución de agentes - ${this.dia}`
                    }, datalabels: {
                        display: (ctx) => ctx.datasetIndex === 0,
                        anchor: 'end',
                        align: 'top',
                        offset: 5,
                        // --- ESTO EVITA QUE LA LÍNEA LO "TACHE" ---
                        color: '#000',
                        font: { weight: 'bold', size: 10 },
                        textStrokeColor: '#fff', // Borde blanco
                        textStrokeWidth: 4,      // Grosor del borde
                        // -----------------------------------------
                        rotation: -45,
                        formatter: (value) => {
                            // Esto muestra el valor tal cual viene en el array de datos
                            return value;
                        },
                        clip: false
                    }

                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            max: this.maxY || this.maxYValue || undefined
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Número de Agentes'
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Intervalos de media hora'
                        }
                    }]
                }
            }
        });
        if (this.activo && this.chart) {
            this.$nextTick(() => {
                this.$emit('grafica-montada', this.dia);
            });
        }

    },
    watch: {
        asignados: {
            handler(nuevo) {
                if (this.chart) {
                    this.chart.data.datasets[0].data = nuevo
                    this.chart.update()
                }
            },
            deep: true
        },
        programados: {
            handler(nuevo) {
                if (this.chart) {
                    this.chart.data.datasets[1].data = nuevo
                    this.chart.update()
                }
            },
            deep: true
        },
        requeridos: {
            handler(nuevo) {
                if (this.chart) {
                    this.chart.data.datasets[2].data = nuevo
                    this.chart.update()
                }
            },
            deep: true
        },
        intervalos(nuevo) {
            if (this.chart) {
                this.chart.data.labels = nuevo
                this.chart.update()
            }
        },
        activo(val) {
            if (val && this.chart) {
                this.$nextTick(() => {
                    this.$emit('grafica-montada', this.dia);
                });
            }
        }

    },
    methods: {
        obtenerImagenGrafica() {
            if (this.chart) {
                return this.chart.toBase64Image(); // devuelve una imagen PNG en base64
            }
            return null;
        },
        descargarGraficaComoPNG() {
            const imagenBase64 = this.obtenerImagenGrafica();
            if (!imagenBase64) return;

            const link = document.createElement('a');
            link.href = imagenBase64;
            link.download = `grafica-${this.dia}.png`;
            link.click();
        }

    }
}
</script>